<template>
<div class="footer_class flex-col">
    <div class="group_23 flex-row">
      <div class="text-wrapper_3 flex-col justify-between">
        <span class="text_15">{{ cooperation.title }}</span>
        <span class="text_16">{{ cooperation.contact }}</span>
        <span class="text_25">{{ cooperation.phone }}</span>
        <span class="text_29">{{ cooperation.email }}</span>
      </div>
      <div class="text-wrapper_4 flex-col justify-between">
        <span class="text_17">{{ about.title }}</span>
        <span style="cursor: pointer;" v-for="(item, index) in about.items" :key="index" class="text_18" @click="handleMenuClick(item.id)">{{ item.name }}</span>
      </div>
      <div class="text-wrapper_6 flex-col">
        <div class="contact-info">
          <span class="text_23">{{ contact.title }}</span>
          <span class="text_24">{{ contact.phone }}</span>
        </div>
        <div class="qrcode-container">
          <div v-for="(qrcode, index) in qrcodes" :key="index" class="qrcode-item">
            <img :src="qrcode.url" class="qrcode-img" alt="二维码">
            <span class="qrcode-text">{{ qrcode.text }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div>
        <a style="color: #FFFFFF" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34110302000404">皖公网安备34110302000404号</a> |
        <a style="color: #FFFFFF" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">皖ICP备2025082448号-1</a>
      </div>

      <span style="margin-top: 10px">Copyright©2025 minsun. All Rights Reserved. 滁州明晟智能科技有限公司版权所有</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterVue',
  data() {
    return {
      cooperation: {
        title: '合作方式',
        contact: '联系人：毕女士',
        phone: '联系电话：13971857112',
        email: '邮箱：biliyuan@minsun.email'
      },
      about: {
        title: '了解更多',
        items:[
          {
            id: 1,
            name:'公司首页',
          },
          {
            id: 2,
            name:'产品中心',
          },
          {
            id: 3,
            name:'解决方案',
          },
          {
            id: 4,
            name:'明晟研究院',
          },
          // {
          //   id: 8,
          //   name:'创作引擎',
          // },
          // {
          //   id: 9,
          //   name:'未来工坊',
          // },
          {
            id: 7,
            name:'关于我们',
          },

        ]
      },
      contact: {
        title: '联系我们',
        phone: '(0550)3013566'
      },
      qrcodes: [
        { text: '企业微信服务', url: require('@/views/common/assets/img/qywx.png') },
        { text: '微信公众号', url: require('@/views/common/assets/img/wxgzh.png') }
      ]
    }
  },
  methods:{
    handleMenuClick(index) {

      // this.selectActive = 21
      // 根据菜单索引进行路由跳转
      switch (index) {
        case 1:
          this.$router.push('/home');
          break;
        case 2:
          this.$router.push('/product');
          break;
        case 3:
          this.$router.push('/scheme');
          break;
        case 4:
          this.$router.push('/minsun_academy');
          break;
        case 6:
          this.$router.push('/minsun_mubanzhongxin');
          break;
        case 7:
          this.$router.push('/about');
          break;
        case 8:
          window.open('http://60.172.131.22:5700/')
          break;
        case 9:
          window.open('https://minsun-ai.com/wlgf/')
          break;
      }
    },
  }
}
</script>

<style scoped>
.bottom{
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer_class {
  background-color: rgba(7, 103, 252, 1);
  width: 100%;
  padding: 30px 0;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  //margin: 60px 0 685px 0;
  //height: 310px;
  z-index: 10;
}

.group_23 {
  width: 80%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
}

.text-wrapper_3,
.text-wrapper_4 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.text-wrapper_6 {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.text_15,
.text_17 {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
}

.text_23 {
  font-size: 24px;
  color: #fff;
  margin-bottom: 5px;
  font-weight: bold;
}

.text_16,
.text_18,
.text_25,
.text_29 {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

.text_24 {
  font-size: 24px;
  /* 增大电话号码字体 */
  color: #fff;
  /* 调整颜色为纯白 */
  line-height: 1.2;
  /* 调整行高 */
  font-weight: bold;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.qrcode-container {
  display: flex;
  gap: 20px;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.qrcode-img {
  width: 95px;
  height: 95px;
  background-color: #fff;
  border-radius: 4px;
}

.qrcode-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
}
</style>
